import { render, staticRenderFns } from "./FileCell.vue?vue&type=template&id=0ce2807e"
import script from "./FileCell.vue?vue&type=script&lang=js"
export * from "./FileCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports